import PropTypes from 'prop-types'

import { NAVIGATION_LABELS } from '../../helpers/constants'

const NavigationLabel = ({ type, locked }) => (
  <div className="navigation-label-wrapper">
    <div className={`navigation-label navigation-label-${type.toLowerCase().split(' ').join('-')}`}>
      {type}
      {locked && <img className="img-icon" src="/images/lock.svg" alt="Lock Icon" />}
    </div>
    {locked && type === NAVIGATION_LABELS.HIDDEN && (
      <img className="img-icon" src="/images/lock.svg" alt="Lock Icon" />
    )}
  </div>
)

NavigationLabel.propTypes = {
  type: PropTypes.string,
  locked: PropTypes.bool,
}

export default NavigationLabel
